import LayoutScreen from '../../components/layout';
import iconArrowLeft from '../../assets/icon/icon_arrow_left.svg';
import imgProduk from '../../assets/image/img-produk-2.png';
import { useNavigate } from 'react-router-dom';
import CardInfoProduk from './cardInfoProduk';
import { useQuery } from '../../components/hook/useQuery';
import { useEffect, useState } from 'react';
import axios from 'axios';
import CONFIG from '../../config/apiConfig';
import parse from 'html-react-parser';
import LogoList from '../../components/logoList';

const PageDetailProduk = (props) => {
  const [detail, setDetail] = useState(null);
  const navigate = useNavigate();
  const query = useQuery();

  const handleBack = () => {
    navigate('/produk'); // Programmatically navigate to /new-route
  };

  useEffect(() => {
    if (query) {
      fetchListProduk();
    }
  }, [query]);

  const fetchListProduk = async () => {
    try {
      const response = await axios.get(
        CONFIG.API_URL + '/products/detail/' + query.get('slug')
      );
      setDetail(response?.data?.data);
    } catch (error) {
      console.error('Error fetching profile:', error);
    }
  };

  return (
    <LayoutScreen transparent>
      <div className="relative flex flex-col flex-grow h-full mt-5">
        <div className="h-full flex flex-col flex-grow justify-start items-center">
          <div className=" w-full flex space-x-4 justify-between items-start">
            <div
              onClick={() => handleBack()}
              className="w-full cursor-pointer flex space-x-2 xl:space-x-4 justify-start items-center">
              <img
                src={iconArrowLeft}
                alt="icon arrow left"
                className="w-5 h-5 xl:w-8 xl:h-8 object-contain"
              />
              <div className=" w-full xl:text-2xl font-semibold text-textBlack">
                Detail Produk
              </div>
            </div>
          </div>

          <div className="flex p-6 bg-white relative  flex-col  w-full mt-4 rounded-xl xl:rounded-3xl">
            <h1 className="font-semibold text-red text-3xl">{detail?.name}</h1>
            <div className="grid xl:grid-cols-2 xl:px-10 gap-10 xl:gap-20 mt-10">
              <div>
                <img
                  src={detail?.image_url}
                  alt="produk1"
                  className="w-full md:w-1/2 xl:w-full object-contain object-center mb-4 p-5 xl:p-10"
                />
                <div className="bg-darkerCream p-5 rounded-2xl">
                  <div className="text-textBlack font-semibold text-2xl">
                    Deskripsi
                  </div>
                  <div className="mt-2 text-justify">
                    {parse(detail?.short_description ?? '')}
                  </div>
                </div>
              </div>
              <div>
                <div>{parse(detail?.description ?? '')}</div>
                {/* <div className="my-5">
                  <hr />
                </div>
                <LogoList /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutScreen>
  );
};

export default PageDetailProduk;
